import config from './config.service';
import {logError} from './logger.service';
import {i18nService} from '@WS_UIkit';
import {setupI18n as setupNewI18n, useI18n} from '@odin/services';


import DEFAULT_LANG_MESSAGES from '@/assets/translations/source.json';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {isBrowser} from '@odin/utils';


export async function setupI18n() {
  setupLegacyI18n();

  // HOTFIX CORS issue on prod
  const i18next = await setupNewI18n({
    debug: config.env === 'development',
    language: config.language,
    defaultNS: 'app',
  });
  const {setLanguage} = useI18n();
  i18nService.onLanguageChange = (lang: string) => setLanguage(lang);

  return i18next;
}




function setupLegacyI18n() {
  if (isBrowser) {
    document.documentElement.setAttribute('lang', config.language!);
  }

  Vue.use(VueI18n);
  i18nService.init({
    messages: DEFAULT_LANG_MESSAGES,
    // https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
    provider: (lang: string) => {
      return import(`../assets/translations/app.${lang}.json`);
    },
    currency: config.currency,
    logger: logError,
  });
}
